import { Component, OnInit } from '@angular/core';
// import { SwUpdate } from '@angular/service-worker';
import { ApiService } from '../../../service/api/api.service';
import { NotificationService } from '../../../service/notification/notification.service';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import { SioService } from '../../../service/sio/sio.service';
declare function initialize(): any;

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [NgSelectModule, RouterModule, FormsModule, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  id_entreprise: string = ""
  granted = false
  loading_update = false
  wrapper: any = false
  les_notifications: any[] = []
  list_notifications: any[] = []
  les_notification_non_lues: any[] = []
  loading_get_notification = false
  loading_update_notification = false
  constructor(public api: ApiService, public not: NotificationService, private swUpdate: SwUpdate, public sio: SioService, private router: Router) {
    this.granted = Notification.permission === "granted"
    if (swUpdate.isEnabled) {
      // Abonnez-vous aux événements de mise à jour
      this.swUpdate.versionUpdates.subscribe(async (event: VersionEvent) => {
        this.loading_update = false
        if (event.type === 'VERSION_READY') {
          console.log('PWA : Une nouvelle version est disponible. Chargement de la nouvelle version... event= ', event);

          // Effectuez une vérification pour éviter les rechargements infinis
          const isUpdateReloaded = localStorage.getItem('isUpdateReloaded');
          if (!isUpdateReloaded) {
            // api.Swal_success("Une nouvelle mise à jour est disponible")
            localStorage.setItem('isUpdateReloaded', 'true');
            if (await api.Swal_confirm("Mise à jour disponible", "Voulez-vous recharger la page ?")) {
              window.location.reload();
            }
            // this.swUpdate.activateUpdate().then(() => {
            //   window.location.reload();
            // });
          } else {
            api.Swal_success("Vous avez la dernière version")
          }
        } else if (event.type === 'VERSION_INSTALLATION_FAILED') {
          console.error('PWA : La mise à jour a échoué.', event);
          // api.Swal_error("Echec de mise à jour. Essayez CTL + Shif + R")
        }
      });

      // Réinitialisez le stockage local après une recharge
      window.addEventListener('load', () => {
        if (localStorage.getItem('isUpdateReloaded')) {
          localStorage.removeItem('isUpdateReloaded');
        }
      });
    } else {
      // window.location.reload();

    }
  }
  ngOnInit(): void {
    this.id_entreprise = this.api.infos.current_entreprise.id_entreprise
    this.get_notification()

    // afficher une notification apres ajout ou modification de commande
    this.sio.on_change(
      'after_add_commande',
      'after_edit_commande',
      (data: any) => {
        this.not.showNotification('Vente', 'Du nouveau dans les ventes');
      }
    );
    // afficher une notification apres ajout ou modification de livraison
    this.sio.on_change(
      'after_add_livraison',
      'after_edit_livraison',
      (data: any) => {
        this.not.showNotification(
          'Livraison',
          'Du nouveau dans les livraisons'
        );
      }
    );
    // les rappels cron
    this.sio.on_change('cron', 'cron', (data: any) => {
      this.get_notification()
      this.not.showNotification(
        data.data.titre || 'Rappel',
        data.data.description || 'Cliquez pour en savoir plus'
      );
    });
  }
  get_notification() {
    this.loading_get_notification = true;
    this.api.taf_post("/notification/get", { id_entreprise: this.api.infos.current_entreprise.id_entreprise }, (reponse: any) => {
      if (reponse.status) {
        this.loading_get_notification = false;
        this.les_notifications = reponse.data
        this.les_notification_non_lues = this.les_notifications.filter((one: any) => one.read_at == null)
        this.list_notifications = reponse.data.reduce((res: any[], one: any) => {
          let actu = Object.assign(one, {})
          actu.icone = actu.read_at == null ? 'bi-bell' : "bi-bell-fill";

          let notification_existe_index = res.findIndex((o: any) => moment(o.created_at).isSame(actu.created_at, "D"))
          if (notification_existe_index != -1) {
            res[notification_existe_index].les_details.push(actu)
          } else {
            res.push({ ...actu, les_details: [actu] })
          }
          return res
        }, [])
        console.log("Opération effectuée avec succés sur la table notification. Réponse= ", reponse);
      } else {
        console.log("L'opération sur la table notification a échoué. Réponse= ", reponse);
        this.api.Swal_error("L'opération a echoué");
      }
      this.loading_get_notification = false;
    }, (error: any) => {
      this.loading_get_notification = false;
    })
  }
  checkForUpdates(): void {
    this.loading_update = true;
    console.log("PWA : checkForUpdates")
    this.swUpdate.checkForUpdate();
    setTimeout(() => {
      this.loading_update = false;
    }, 10000);
  }

  changement(event: any) {
    // this.api.sendEvent(event)
  }
  entreprise_change() {
    this.api.infos.current_entreprise = this.api.infos.les_entreprises.filter((one: any) => one.id_entreprise == this.id_entreprise)[0]
    this.api.save_on_local_storage("infos", this.api.infos)

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
  show_notification() {
    if (this.les_notification_non_lues.length == 0) {
      return
    }
    this.update_notification({
      condition: { id_entreprise: this.api.infos.current_entreprise.id_entreprise },
      data: { read_at: moment().format("YYYY-MM-DD") }
    })
  }
  update_notification(params: any) {
    this.loading_update_notification = true;
    this.api.taf_post("/notification/edit", params, (reponse: any) => {
      if (reponse.status) {
        this.get_notification()
        console.log("Opération effectuée avec succés sur la table notification. Réponse= ", reponse);
      } else {
        console.log("L'opération sur la table notification a échoué. Réponse= ", reponse);
        this.api.Swal_error("L'opération a echoué");
      }
      this.loading_update_notification = false;
    }, (error: any) => {
      this.loading_update_notification = false;
    })
  }
  changerVersion(version: string) {
    window.location.href = 'https://bi.jant.tech/' + version +"/";
  }

}
